/**
 * App entry — mounts the router. Full-screen always: the app owns the whole
 * viewport on every screen, web and mobile web.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { installCrashReporter } from './crash.js';
import './index.css';

// Scope-system §5: uncaught errors auto-report to the owner desk.
installCrashReporter();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
